import { useUserStore } from "../../store/userStore";
import { API_BASE_URL } from "../../config/env";
import { isDesignMode } from "../../config/designMode";
import { useSnackbarStore } from "src/store/snackbarStore";
//export const API_BASE_URL = "http://localhost:8080"; // ou importe de env

export async function apiFetch(
    endpoint: string,
    options: RequestInit = {}
) {
    if (isDesignMode) {
        const { resolveDesignMock } = await import("../../design/resolveDesignMock");
        return resolveDesignMock(endpoint, options);
    }

    const token = useUserStore.getState().tokens.backendToken;
    const showSnackbar = useSnackbarStore.getState().showSnackbar;

    // não é necessario enviar o token no endpoint de autenticação
    const skipAuth = endpoint.includes("/auth/cognito");

    const headers: HeadersInit = {
        "Content-Type": "application/json",
        ...(options.headers || {}),
        ...(skipAuth ? {} : { Authorization: `Bearer ${token}` }),
    };
    try {
        const response = await fetch(`${API_BASE_URL}${endpoint}`, {
            ...options,
            headers,
        });
        if (!response.ok) {
            const text = await response.text();
            showSnackbar(
                `Erro ao comunicar com o servidor. ${text}`,
                "error"
            );
            throw new Error(`Erro ${response.status}: ${text}`);
        }
        return response.json();
    }

    catch (error) {
        showSnackbar(
            "Erro inesperado ao comunicar com o servidor.",
            "error"
        );
        throw error;
    }
}
